<template>
  <Modal
    class="tw-translate-y-[-50%] offer-access-modal"
    :max-width="DEFAULT_MAX_WIDTH_MODAL"
    :visible="showRef"
    :value="formModel"
    @close="handleCloseModal"
  >
    <ModalHeader :title="titleHeader" @close="handleCloseModal" />
    <div class="tw-p-10 modal-offer-access">
      <div class="tw-flex tw-items-center tw-gap-[15px]">
        <span
          class="tw-text-[25px] tw-text-[#211F58] tw-font-[600] tw-leading-none"
          >{{
            getComponentUiText(
              "app-settings-organisation-manage-access-offer-modal-subtitle-1",
            )
          }}</span
        >
      </div>
      <BaseForm :show="showRef" :enter-event="true" @on:submit="onSubmit">
        <!-- Field : Email -->
        <BaseInput
          id="name"
          v-model="formModel.email"
          :validation="vueValidate.email"
          :validate-on-blur="true"
          :label="getComponentUiText('app-user-profile-form-label-email-1')"
          :label-tooltip="
            getComponentUiText(
              'app-settings-organisation-manage-access-offer-modal-description-email-1',
            )
          "
          :placeholder="
            getComponentUiText('app-user-profile-form-label-email-1')
          "
        />
        <!-- Field : Org Relationship -->
        <BaseInput
          id="lock-status"
          v-model="formModel.orgToOrgTypeId"
          :validation="vueValidate.orgToOrgTypeId"
          :validate-on-blur="true"
          :label="
            getComponentUiText(
              'app-settings-organisation-manage-access-modals-label-org-relationship-1',
            )
          "
        >
          <div class="dropdown">
            <BaseDropDown
              :id="'orgToOrgTypeId'"
              v-model="formModel.orgToOrgTypeId"
              :data="orgRelationshipOptions"
              :validation="vueValidate.orgToOrgTypeId"
              :class-name="'gray-dropdown-container tw-h-[58px]'"
              :placeholder="
                getComponentUiText(
                  'app-settings-organisation-manage-access-modals-prompt-org-relationship-1',
                )
              "
            />
          </div>
        </BaseInput>
        <!-- Field : Lock status -->
        <BaseInput
          v-if="handleLockStatus()"
          id="lock-status"
          v-model="formModel.isLocked"
          :validation="vueValidate.isLocked"
          :label="
            getComponentUiText(
              'app-settings-organisation-manage-access-modals-label-lock-status-1',
            )
          "
          :label-tooltip="
            getComponentUiText(
              'app-settings-organisation-manage-access-offer-modal-description-lock-status-1',
            )
          "
          :validate-on-blur="true"
        >
          <div class="dropdown">
            <BaseDropDown
              :id="'isLocked'"
              v-model="formModel.isLocked"
              :data="lockStatusOptions"
              :validation="vueValidate.isLocked"
              :class-name="'gray-dropdown-container tw-h-[58px]'"
              :placeholder="
                getComponentUiText(
                  'app-settings-organisation-manage-access-modals-prompt-lock-status-1',
                )
              "
            >
              <template #button-content>
                <div class="tw-flex tw-justify-between">
                  <div>
                    <img
                      v-if="formModel.isLocked"
                      class="tw-h-[14px] tw-w-[14px] tw-mr-[10px]"
                      src="/img/lock1_icon.svg"
                      alt="icon"
                    />
                    <span :class="'tw-text-[#231F20]'">{{
                      lockStatusOptions.find(
                        (m) => m.value === formModel.isLocked,
                      )?.name
                    }}</span>
                  </div>
                  <img
                    class="right-arrow"
                    src="/img/blue_right_arrow_icon.svg"
                  />
                </div>
              </template>
            </BaseDropDown>
          </div>

          <template #feedback>
            <div
              v-if="formModel.isLocked === false"
              class="tw-flex tw-bg-[#FE9A0526] tw-text-[11px] tw-text-[#FE9A05] tw-font-medium tw-mt-[10px] tw-leading-[130%] tw-py-[8px] tw-px-[12px] tw-rounded-md"
            >
              <div class="tw-flex tw-item-center tw-mr-[10px]">
                <img src="@/assets/img/warning-orange-icon.svg" />
              </div>
              <span>{{
                getComponentUiText(
                  "app-settings-organisation-manage-access-modals-warning-lock-status-1",
                )
              }}</span>
            </div>
          </template>
        </BaseInput>
        <!-- Field : Roles -->
        <BaseInput
          v-model="formModel.roleId"
          :validation="vueValidate.roleId"
          :placeholder="
            getComponentUiText('app-component-custom-b-dropdown-prompt-roles-1')
          "
          :label="
            getComponentUiText(
              'app-settings-organisation-manage-access-manage-offer-modal-form-label-role-1',
            )
          "
        >
          <div class="dropdown">
            <BaseDropDown
              :id="'roleId'"
              v-model="formModel.roleId"
              :data="roles"
              :validation="vueValidate.roleId"
              :class-name="'gray-dropdown-container tw-min-h-[58px] tw-text-[#FFFFFF]'"
              :placeholder="
                getComponentUiText(
                  'app-component-custom-b-dropdown-prompt-roles-1',
                )
              "
            />
          </div>
        </BaseInput>
        <div class="button-container tw-flex tw-justify-end tw-mt-[40px]">
          <ButtonLoading
            :class="`button-verify tw-bg-[#387DFF] tw-text-[15px] tw-font-medium tw-rounded-[27px]`"
            :title="
              getComponentUiText(
                'app-settings-organisation-manage-access-offer-modal-offer-access-button-1',
              )
            "
            :is-loading="isCallApi"
            type="submit"
          />
        </div>
      </BaseForm>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import {
  IsEmailValidWhileTyping,
  IsSpecialCharEmailValid,
  getComponentUiText,
} from "@/utils/utilities";
import { onBeforeMount, reactive, ref, watch, Ref, computed } from "vue";

import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import useVuelidate from "@vuelidate/core";
import { email, required, helpers } from "@vuelidate/validators";
import { IOrgAccessOfferRequest } from "@/interfaces/orgInterfaces";
import { postOrgAccessOffer } from "@/services/org";
import BaseInput from "@/components/common/form/baseInput.vue";
import BaseDropDown from "@/components/common/form/baseDropDown.vue";
import store from "@/store";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import BaseForm from "../common/form/baseForm.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Invite } from "@/services/apiRoutes/routes";
import ButtonLoading from "../common/buttonLoading.vue";
const DEFAULT_MAX_WIDTH_MODAL = 65;

const orgRelationshipOptions: Ref<IDropDownData[]> = computed(() => {
  const orgAccessType = store.getters["Org/getOrgAccessType"];
  return orgAccessType.map((relationship) => ({
    name: relationship.name,
    id: relationship.id,
    isLockable: relationship.isLockable,
  }));
});

const lockStatusOptions: IDropDownData[] = [
  {
    id: true,
    value: true,
    name: getComponentUiText(
      "app-settings-organisation-manage-access-create-org-modal-locked-status-1",
    ),
    iconSrc: "/img/lock1_icon.svg",
  },
  {
    id: false,
    value: false,
    name: getComponentUiText(
      "app-settings-organisation-manage-access-create-org-modal-unlocked-status-1",
    ),
  },
];

const roles: Ref<IDropDownData[]> = computed(() => {
  const rolesData = store.getters["Org/getOrgRolesData"];
  return rolesData.map((role) => ({
    name: role.roleName,
    id: role.roleId,
  }));
});

const listNotValidDomain = computed(
  () => store.getters["Org/getOrgDomainsInvalid"],
);

const currentOrg = computed(() => store.state.Org.currentOrg);

const titleHeader = ref("");
const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
});
const isCallApi = ref(false);

const emit = defineEmits(["update:show", "add:organisation"]);

// Custom validation domain.
const validateForDomain = (text: string) => {
  return !listNotValidDomain.value.some((domain) => text.includes(domain));
};
// Form modal and validation.

const initialForm: IOrgAccessOfferRequest = {
  email: "",
  orgToOrgTypeId: null,
  isLocked: true,
  roleId: "",
};
const formModel = reactive({ ...initialForm });
const getDomainMessage = computed(() => {
  const email = formModel.email;
  return getComponentUiText(
    "app-settings-organisation-manage-access-modals-error-domain-already-access-1",
    false,
    { domain: email?.match(/@([a-zA-Z0-9.-]+)$/)?.[1] || "" },
  );
});
const rules = {
  email: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsEmailValidWhileTyping,
    ),
    notDomainValid: helpers.withMessage(
      () => getDomainMessage.value,
      validateForDomain,
    ),
    email: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsSpecialCharEmailValid,
    ),
  },
  orgToOrgTypeId: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  isLocked: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  roleId: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
};

const vueValidate = useVuelidate(rules, formModel);
let showRef = ref(props.show);
let notInfoVisible = ref(true);

const clearData = () => {
  for (const key in formModel) {
    if (Array.isArray(formModel[key])) {
      formModel[key].splice(0); // Clear the array content while maintaining reference
    } else {
      formModel[key] = initialForm[key];
    }
  }

  vueValidate.value.$reset();
};

const handleCloseModal = () => {
  clearData();
  showRef.value = false;
  emit("update:show", showRef.value);
};

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) notInfoVisible.value = true;
  },
);

const toastSuccess = getComponentUiText(
  "app-settings-organisation-manage-access-offer-modal-toast-org-offer-access-1",
);

const onSubmit = async () => {
  await vueValidate.value.$validate();
  if (vueValidate.value.$invalid) return;

  try {
    isCallApi.value = true;
    const formResponse = await postOrgAccessOffer({
      ...formModel,
      roleId: `${formModel.roleId}`,
    });
    if (formResponse.data?.data) {
      emit("add:organisation", formResponse.data.data);
      onShowToast(toastSuccess, ToastVariant.SUCCESS);
      handleCloseModal();
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Invite.orgAccessOffer);
    }
  } finally {
    isCallApi.value = false;
  }
};

const onShowToast = (message: string, variant: ToastVariant) => {
  const emitData: IToastMessage = { variant, message };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const getFormData = async () => {
  titleHeader.value = getComponentUiText(
    "app-settings-organisation-manage-access-offer-modal-title-1",
    false,
    { name: currentOrg.value.name },
  );
};

const handleLockStatus = () => {
  const isShowLockStatus =
    orgRelationshipOptions.value.find(
      (org) => org.id === formModel.orgToOrgTypeId,
    )?.isLockable === true;
  if (isShowLockStatus) return true;
  return false;
};

onBeforeMount(() => {
  getFormData();
});

watch(
  () => currentOrg.value,
  async (newValue, oldValue) => {
    if (newValue.id && newValue.id !== oldValue.id) {
      await getFormData();
    }
  },
  { deep: true },
);
</script>

<style lang="scss">
.offer-access-modal {
  .button-verify.btn.btn-primary[disabled] {
    background-color: #dbdbdb;
    color: #b7b7b7;
    border-color: #dbdbdb;
  }

  .copy-info-container {
    max-width: 70%;
  }

  .text-copy-container {
    width: calc(100% - 22px);
  }

  .button-delete {
    line-height: 100%;
    background-color: #f7553c;
    border-color: #f7553c;
  }

  .button-verify-later {
    line-height: 100%;
    border: 2px solid #387dff;
    background-color: #ffffff;
    color: #387dff;
  }

  .button-verify {
    line-height: 100%;
    background-color: #387dff;
    border-color: #387dff;
  }

  .status-domain {
    padding: 3px 5px;
    font-family: Poppins;
    font-size: 11px;
    font-weight: 500;
    line-height: 130%;
    border-radius: 4px;

    background: var(--ui-green-soft, #d9ede2);
    color: #01893d;
  }
}

@media (min-height: 768px) {
  .offer-access-modal {
    .modal-main {
      overflow: visible;

      .dropdown-menu {
        max-height: 169px;
        overflow: auto;
      }
    }
  }
}

@media (max-width: 991px) {
  .offer-access-modal {
    .copy-info-container {
      max-width: fit-content;
    }
  }
}

@media (max-width: 420px) {
  .offer-access-modal {
    .button-container-left {
      margin-top: 10px;
    }

    .field-container {
      flex-direction: column;
      align-items: flex-start;
    }

    .input-container {
      width: 100%;
      margin-top: 12px;
    }

    .label-container {
      width: unset !important;
    }
  }
}
</style>
